<template>
  <div class="app-footer-wrapper">
    <!-- CTA 区域：开启企业数字化升级之路 -->
    <section class="cta-section">
      <div class="cta-content">
        <h2 class="cta-title">开启企业数字化升级之路</h2>
        <div class="cta-buttons">
          <button class="btn btn-primary" @click="$emit('open-modal')">获取定制方案 <span class="arrow">&gt;</span></button>
          <button class="btn btn-outline" @click="$emit('open-modal')">预约演示 <span class="arrow">&gt;</span></button>
        </div>
      </div>
    </section>

    <!-- 页脚主区域 -->
    <footer class="main-footer">
      <div class="footer-container">
        <!-- 顶部信息区 -->
        <div class="footer-top">
          <!-- 左侧品牌与简介 -->
          <div class="footer-brand">
            <div class="brand-logo-area">
              <!-- <img src="/favicon.ico" alt="至讯 Logo" class="footer-logo-img" /> -->
              <span class="brand-name">北京至讯信息技术有限公司</span>
            </div>
          </div>

          <!-- 中间链接组 -->
          <div class="footer-links-group">
            <div class="link-column">
              <h4>产品与服务</h4>
              <ul>
                <li><a href="https://ioa.cloud.tencent.com/" target="_blank">腾讯安全 iOA</a></li>
                <li><a href="https://cloud.tencent.com/product/adp" target="_blank">AI 智能体</a></li>
                <li><a href="https://cloud.tencent.com/" target="_blank">腾讯云服务</a></li>
                <li><a href="https://meeting.tencent.com/" target="_blank">腾讯会议</a></li>
              </ul>
            </div>
            <div class="link-column">
              <h4>解决方案</h4>
              <ul>
                <li><a href="#" @click.prevent="$emit('open-modal')">零信任安全</a></li>
                <li><a href="#" @click.prevent="$emit('open-modal')">AI 场景落地</a></li>
                <li><a href="#" @click.prevent="$emit('open-modal')">企业微信方案</a></li>
                <li><a href="#" @click.prevent="$emit('open-modal')">产品定制开发</a></li>
              </ul>
            </div>
            <div class="link-column">
              <h4>关于至讯</h4>
              <ul>
                <li><a href="#about" @click="scrollTo($event, 'about')">公司介绍</a></li>
                <li><a href="#products" @click="scrollTo($event, 'products')">产品服务</a></li>
                <li><a href="#honors" @click="scrollTo($event, 'honors')">荣誉资质</a></li>
                <li><a href="#contact" @click="scrollTo($event, 'contact')">联系我们</a></li>
              </ul>
            </div>
          </div>

          <!-- 右侧联系方式 -->
          <div class="footer-contact">
            <div class="contact-item">
              <svg class="contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              <span>17762443986</span>
            </div>
            <div class="contact-item">
              <svg class="contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <span>zhoufeng@wxzhixun.com</span>
            </div>
            <div class="contact-item align-top">
              <svg class="contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span class="address-text">北京市海淀区西四环北路158号</span>
            </div>
            <button class="btn-message" @click="$emit('open-modal')">在线留言</button>
          </div>
        </div>

        <!-- 底部版权区 -->
        <div class="footer-bottom">
          <div class="copyright">
            © 2015 - 2024 北京至讯信息技术有限公司 版权所有 
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="beian-link">京ICP备18044096号</a>
          </div>
          <!-- 暂时隐藏隐私政策和服务条款 -->
          <div class="legal-links" style="display: none;">
            <a href="#" class="legal-link">
              <svg class="shield-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                <path d="M9 12l2 2 4-4"></path>
              </svg>
              隐私政策
            </a>
            <span class="divider"></span>
            <a href="#" class="legal-link">
              <svg class="shield-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                <path d="M9 12l2 2 4-4"></path>
              </svg>
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  methods: {
    scrollTo(event, id) {
      if (event) event.preventDefault()
      const element = document.getElementById(id)
      if (element) {
        const offset = 100
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - offset
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
      } else if (id === 'home') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.app-footer-wrapper {
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

/* --- CTA 区域样式 --- */
.cta-section {
  position: relative;
  background: url('../assets/footer.png') no-repeat center center;
  background-size: cover;
  padding: clamp(80px, 10vw, 140px) clamp(20px, 4vw, 40px);
  text-align: center;
  overflow: hidden;
}

.cta-content {
  position: relative;
  z-index: 2;
}

.cta-title {
  font-size: clamp(24px, 3vw, 36px);
  font-weight: 600;
  color: #fff;
  margin-bottom: 40px;
  letter-spacing: 2px;
  text-shadow: 0 2px 10px rgba(0,0,0,0.3);
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 32px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.btn .arrow {
  margin-left: 8px;
  font-family: monospace;
  font-size: 14px;
}

.btn-primary {
  background-color: #fff;
  color: #0052d9;
  border: none;
}
.btn-primary:hover {
  background-color: #f0f5ff;
  box-shadow: 0 4px 12px rgba(255,255,255,0.2);
}

.btn-outline {
  background-color: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.6);
}
.btn-outline:hover {
  background-color: rgba(255,255,255,0.1);
  border-color: #fff;
}


/* --- 页脚主区域样式 --- */
.main-footer {
  background-color: #0d1627;
  color: #8b94a5;
  padding: 60px 0 20px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
}

/* 品牌与简介 */
.footer-brand {
  width: 300px;
}

.brand-logo-area {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.footer-logo-img {
  width: 48px;
  height: 48px;
  object-fit: contain;
  margin-right: 12px;
}

.brand-name {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
}

.brand-desc {
  font-size: 13px;
  line-height: 1.8;
  margin: 0 0 8px 0;
}

/* 链接组 */
.footer-links-group {
  display: flex;
  flex: 1;
  justify-content: space-between;
  padding: 0 60px;
  border-right: 1px solid rgba(255,255,255,0.05);
}

.link-column h4 {
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  margin: 0 0 20px 0;
}

.link-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-column li {
  margin-bottom: 12px;
}

.link-column a {
  color: #8b94a5;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s;
}

.link-column a:hover {
  color: #00d2ff;
}

/* 联系方式 */
.footer-contact {
  width: 260px;
  padding-left: 40px;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 13px;
  color: #b0b8c6;
}

.contact-item.align-top {
  align-items: flex-start;
}

.contact-icon {
  width: 16px;
  height: 16px;
  margin-right: 12px;
  flex-shrink: 0;
  opacity: 0.8;
}

.address-text {
  line-height: 1.6;
}

.btn-message {
  margin-top: 10px;
  background-color: #165dff;
  color: #fff;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-message:hover {
  background-color: #004ecc;
}

/* 底部版权区 */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  border-top: 1px solid rgba(255,255,255,0.05);
  font-size: 12px;
  color: #6c778c;
}

.copyright .gap {
  display: inline-block;
  width: 20px;
}

.beian-link {
  color: #6c778c;
  text-decoration: none;
  transition: color 0.3s;
}

.beian-link:hover {
  color: #fff;
}

.legal-links {
  display: flex;
  align-items: center;
}

.legal-link {
  display: flex;
  align-items: center;
  color: #6c778c;
  text-decoration: none;
  transition: color 0.3s;
}

.legal-link:hover {
  color: #fff;
}

.shield-icon {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}

.legal-links .divider {
  display: inline-block;
  width: 1px;
  height: 12px;
  background-color: rgba(255,255,255,0.1);
  margin: 0 16px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .footer-brand {
    width: 240px;
  }
  .footer-links-group {
    padding: 0 30px;
    flex-wrap: wrap;
    gap: 20px 0;
  }
  .link-column {
    min-width: calc(33.333% - 14px);
  }
  .footer-contact {
    width: 220px;
    padding-left: 20px;
  }
}

@media (max-width: 1024px) {
  .footer-top {
    flex-wrap: wrap;
  }
  .footer-links-group {
    padding: 0 20px;
  }
  .footer-contact {
    width: 100%;
    padding-left: 0;
    margin-top: 40px;
    border-top: 1px solid rgba(255,255,255,0.05);
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
  }
  .contact-item {
    margin-bottom: 0;
  }
}

@media (max-width: 768px) {
  .main-footer {
    padding: 40px 0 20px;
  }
  .footer-brand {
    width: 100%;
    margin-bottom: 40px;
  }
  .brand-name {
    font-size: 16px;
  }
  .footer-links-group {
    flex-wrap: wrap;
    border-right: none;
    padding: 0;
  }
  .link-column {
    width: 33.33%;
    margin-bottom: 30px;
    min-width: auto;
  }
  .footer-bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
  .footer-contact {
    justify-content: flex-start;
  }
}

@media (max-width: 600px) {
  .cta-section {
    padding: 60px 16px;
  }
  .cta-title {
    margin-bottom: 24px;
    letter-spacing: 1px;
  }
  .cta-buttons {
    flex-direction: column;
    gap: 12px;
  }
  .cta-buttons .btn {
    width: 100%;
    justify-content: center;
  }
  .main-footer {
    padding: 32px 0 16px;
  }
  .footer-top {
    margin-bottom: 24px;
  }
  .link-column {
    width: 50%;
    margin-bottom: 20px;
  }
  .link-column h4 {
    font-size: 14px;
    margin-bottom: 12px;
  }
  .link-column a {
    font-size: 12px;
  }
  .btn {
    padding: 10px 20px;
    font-size: 14px;
  }
  .btn-message {
    width: 100%;
    padding: 12px 0;
  }
  .footer-bottom {
    flex-direction: column;
    gap: 12px;
    text-align: center;
    font-size: 11px;
    line-height: 1.6;
  }
  .legal-links {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }
  .legal-links .divider {
    display: none;
  }
}
</style>